// SpinnerOverlay.jsx
import React from 'react';
import './SpinnerOverlay.css';

const SpinnerOverlay = () => {
  return (
    <div className="overlay">
      <div className="spinner">
        <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      </div>
    </div>
  );
};

export default SpinnerOverlay;